import { io } from "socket.io-client";
import { BACKEND_API_BASE_URL } from "../utilities/constant";

const SOCKET_BASE_URL = BACKEND_API_BASE_URL.replace(/\/api$/, "");
const socket = io(SOCKET_BASE_URL, {
  autoConnect: false,
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 1000,
});

export default socket;